import React, { useState } from 'react';
import { 
  HelpCircle, Book, FileText, Keyboard, Mail, Phone, 
  ChevronDown, ChevronRight, Users, Building2, ShoppingCart, 
  Package, BarChart3, Search, Upload, Globe, CheckCircle,
  Key, MapPin, Filter, ExternalLink, Zap, Truck, CreditCard,
  CalendarClock, Info, GraduationCap, Megaphone, Magnet, Wrench,
  Boxes, FileCheck, FileSpreadsheet, Settings2, ClipboardList,
  UsersRound, DollarSign, FileUp, UserPlus, ScanLine, Warehouse,
  Brain, Bell, Clock
} from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';

// Ghid per modul - TOATE MODULELE in ordinea din sidebar
const MODULE_GUIDES = [
  // ===== PRINCIPAL =====
  {
    id: 'dashboard',
    title: 'Dashboard',
    icon: BarChart3,
    color: 'text-orange-600',
    bgColor: 'bg-orange-50',
    sections: [
      {
        title: 'Prezentare generala',
        content: `Dashboard-ul ofera o vedere de ansamblu asupra activitatii firmei:
- Carduri cu statistici rapide: numar clienti, comenzi active, valori totale
- Grafice interactive cu evolutia vanzarilor pe luni
- Lista ultimelor comenzi si statusul lor actual
- Notificari si alerte importante`
      },
      {
        title: 'Carduri statistice',
        content: `Fiecare card afiseaza:
- Valoarea sau numarul curent
- Procentul de crestere/scadere fata de luna anterioara
- Iconita reprezentativa pentru categoria respectiva
Click pe un card pentru a naviga direct la modulul corespunzator.`
      },
      {
        title: 'Grafice',
        content: `Graficele pot fi filtrate dupa:
- Perioada (ultimele 7 zile, 30 zile, 12 luni)
- Tip date (valoare, numar comenzi, numar clienti noi)
Hover pe punctele graficului pentru detalii.`
      }
    ]
  },
  {
    id: 'pontaj',
    title: 'Pontaj',
    icon: CalendarClock,
    color: 'text-teal-600',
    bgColor: 'bg-teal-50',
    sections: [
      {
        title: 'Evidenta timpului de lucru',
        content: `Modulul Pontaj permite inregistrarea si gestionarea orelor de lucru:
- Vizualizare calendar cu prezente zilnice
- Inregistrare ore lucrate, concedii, absente
- Rapoarte lunare per angajat sau departament
- Export date pentru calcul salarii`
      },
      {
        title: 'Adaugare pontaj',
        content: `Pentru a inregistra pontajul:
1. Selectati angajatul din lista
2. Alegeti luna si anul dorit
3. Completati orele pentru fiecare zi lucratoare
4. Marcati zilele de concediu sau absenta
5. Salvati inregistrarile`
      },
      {
        title: 'Rapoarte pontaj',
        content: `Generati rapoarte pentru:
- Total ore lucrate pe angajat
- Ore suplimentare
- Zile de concediu consumate vs disponibile
- Export Excel pentru contabilitate`
      }
    ]
  },
  {
    id: 'informatii',
    title: 'Informatii',
    icon: Info,
    color: 'text-blue-600',
    bgColor: 'bg-blue-50',
    sections: [
      {
        title: 'Pagina Informatii',
        content: `Aceasta pagina ofera acces rapid la informatii generale:
- Anunturi interne si noutati
- Documente si proceduri importante
- Link-uri utile pentru angajati
- Informatii despre companie`
      },
      {
        title: 'Documente interne',
        content: `Accesati:
- Regulamente si proceduri
- Formulare standard
- Materiale de training
- Prezentari si ghiduri`
      }
    ]
  },
  {
    id: 'antrenament',
    title: 'Antrenament',
    icon: GraduationCap,
    color: 'text-amber-600',
    bgColor: 'bg-amber-50',
    sections: [
      {
        title: 'Modulul de Training',
        content: `Platforma de antrenament pentru angajati:
- Cursuri si materiale educationale
- Teste de evaluare
- Certificari interne
- Progres individual per angajat`
      },
      {
        title: 'Accesare cursuri',
        content: `Pentru a accesa un curs:
1. Selectati categoria de interes
2. Alegeti cursul dorit
3. Parcurgeti materialele in ordine
4. Completati testul de evaluare
5. Obtineti certificatul (daca treceti testul)`
      }
    ]
  },
  {
    id: 'marketing',
    title: 'Marketing',
    icon: Megaphone,
    color: 'text-pink-600',
    bgColor: 'bg-pink-50',
    sections: [
      {
        title: 'Campanii Marketing',
        content: `Gestionati activitatile de marketing:
- Planificare si urmarire campanii
- Materiale promotionale
- Analize si statistici campanii
- Calendar activitati marketing`
      },
      {
        title: 'Materiale promotionale',
        content: `Organizati si accesati:
- Brosuri si cataloage
- Prezentari pentru clienti
- Template-uri email
- Imagini si logo-uri`
      }
    ]
  },
  {
    id: 'magnet',
    title: 'Magnet',
    icon: Magnet,
    color: 'text-violet-600',
    bgColor: 'bg-violet-50',
    sections: [
      {
        title: 'Lead Magnet',
        content: `Instrument pentru atragerea si calificarea lead-urilor:
- Formulare de captare lead-uri
- Landing pages integrate
- Tracking sursa lead
- Scorare automata lead-uri`
      },
      {
        title: 'Gestionare lead-uri',
        content: `Pentru fiecare lead capturat:
- Vizualizati sursa (site, campanie, referral)
- Verificati scorul de calitate
- Atribuiti unui agent
- Convertiti in contact CRM`
      }
    ]
  },
  {
    id: 'crm',
    title: 'CRM',
    icon: Users,
    color: 'text-cyan-600',
    bgColor: 'bg-cyan-50',
    sections: [
      {
        title: 'Customer Relationship Management',
        content: `Modulul CRM gestioneaza relatiile cu clientii si oportunitatile:
- Contacte Dealeri: contacte noi, fara oferte trimise
- Oportunitati Dealeri: contacte cu oferte in derulare
- Clienti Activi: contacte convertite in clienti`
      },
      {
        title: 'Adaugare contact',
        content: `1. Click pe butonul "Adauga"
2. Completati datele de contact (nume, telefon, email)
3. Selectati agentul responsabil
4. Adaugati note despre oportunitate
5. Salvati si incepeti urmarirea`
      },
      {
        title: 'Actiuni disponibile',
        content: `Pentru fiecare contact puteti:
- Adauga activitati (apeluri, intalniri, email-uri)
- Inregistra note si observatii
- Genera si trimite oferte
- Programa follow-up automat
- Converti in client la finalizarea vanzarii`
      },
      {
        title: 'Pipeline vanzari',
        content: `Urmariti progresul oportunitatilor:
- Nou - Contactat - Oferta trimisa - Negociere - Castigat/Pierdut
- Filtrare dupa status, agent, valoare
- Rapoarte de conversie si performanta`
      }
    ]
  },
  {
    id: 'clienti',
    title: 'Clienti',
    icon: Building2,
    color: 'text-blue-600',
    bgColor: 'bg-blue-50',
    sections: [
      {
        title: 'Baza de date clienti',
        content: `Pagina Clienti contine toti clientii activi ai firmei:
- Date complete: nume, CUI, adrese, contacte
- Istoric comenzi per client
- Documente atasate
- Note si observatii`
      },
      {
        title: 'Adaugare client nou',
        content: `1. Click pe butonul "Adauga" din dreapta sus
2. Completati campurile obligatorii (marcat cu *)
3. Pentru firme, folositi ANAF sau VIES pentru auto-completare
4. Adaugati adrese multiple daca e necesar
5. Click "Salveaza" pentru finalizare`
      },
      {
        title: 'Cautare VIES (firme UE)',
        content: `Butonul verde "VIES" cauta firme din Uniunea Europeana:
- Introduceti codul VAT complet (ex: DE123456789)
- Functioneaza pentru toate tarile UE
- Auto-completeaza: nume, adresa, status TVA`
      },
      {
        title: 'Cautare ANAF (firme RO)',
        content: `Butonul albastru "ANAF" cauta firme romanesti:
- Introduceti CUI-ul (cu sau fara RO)
- Returneaza: nume, adresa, status TVA
- Link-uri directe catre ANAF si ONRC`
      },
      {
        title: 'Import din Excel',
        content: `Pentru import in masa:
1. Click "Import Excel"
2. Descarcati sablonul
3. Completati datele in Excel
4. Incarcati fisierul (.xlsx, .csv)
5. Verificati rezultatul importului`
      }
    ]
  },
  {
    id: 'furnizori',
    title: 'Furnizori',
    icon: Package,
    color: 'text-purple-600',
    bgColor: 'bg-purple-50',
    sections: [
      {
        title: 'Gestionare furnizori',
        content: `Pagina Furnizori contine toti furnizorii firmei:
- Date firma: nume, CUI, adresa
- Persoane de contact
- Produse/servicii oferite
- Conditii comerciale si contracte`
      },
      {
        title: 'Adaugare si editare',
        content: `Functioneaza similar cu modulul Clienti:
- Cautare ANAF/VIES pentru auto-completare
- Adrese multiple
- Import din Excel
- Atasare documente (contracte, certificate)`
      }
    ]
  },
  {
    id: 'producatori',
    title: 'Producatori',
    icon: Wrench,
    color: 'text-indigo-600',
    bgColor: 'bg-indigo-50',
    sections: [
      {
        title: 'Lista producatorilor',
        content: `Gestionati producatorii cu care colaborati:
- Date firma si contact
- Capacitati de productie
- Termene standard de livrare
- Istoric comenzi si evaluari`
      },
      {
        title: 'Evaluare producatori',
        content: `Urmariti performanta fiecarui producator:
- Respectarea termenelor
- Calitatea produselor
- Preturi si conditii
- Rating general`
      }
    ]
  },
  {
    id: 'comenzi_vanzare',
    title: 'Comenzi Vanzare',
    icon: ShoppingCart,
    color: 'text-green-600',
    bgColor: 'bg-green-50',
    sections: [
      {
        title: 'Gestionare comenzi',
        content: `Modulul central pentru vanzari:
- Creare si editare comenzi
- Urmarire status si livrari
- Generare documente (proforme, facturi)
- Rapoarte vanzari per agent/client`
      },
      {
        title: 'Creare comanda noua',
        content: `1. Click "Adauga" pentru comanda noua
2. Selectati clientul din lista
3. Adaugati produsele/serviciile
4. Completati detaliile (valoare, termen, observatii)
5. Atribuiti agentul responsabil
6. Salvati comanda`
      },
      {
        title: 'Workflow status',
        content: `Statusurile comenzilor:
- Noua: Comanda tocmai creata
- In procesare: Se pregateste livrarea
- Livrata: Produsele au fost expediate
- Facturata: Factura emisa
- Finalizata: Plata incasata, ciclu complet`
      },
      {
        title: 'Generare Proforma',
        content: `Pentru a genera proforma:
1. Deschideti comanda dorita
2. Click pe butonul "Proforma"
3. Alegeti tipul: RON/EUR, cu/fara TVA
4. PDF-ul se descarca automat
Datele furnizorului sunt preluate din Configurari Firma.`
      }
    ]
  },
  {
    id: 'comenzi_achizitie',
    title: 'Comenzi Achizitie',
    icon: Warehouse,
    color: 'text-orange-600',
    bgColor: 'bg-orange-50',
    sections: [
      {
        title: 'Comenzi catre furnizori',
        content: `Gestionati achizitiile de la furnizori:
- Creare comenzi de achizitie
- Urmarire status productie
- Receptie si verificare
- Matching cu comenzile de vanzare`
      },
      {
        title: 'Workflow productie',
        content: `Statusuri detaliate pentru productie:
Noua - Proiect-ok1 - Proiect-ok2 - Start-ok - 
Cadre-ok - Livrare-S1 - Start-S1 - Orificii-ok - 
Slefuire-ok - Vopsire-ok - Feronerie-ok - 
Vitraj-ok - Executat-ok - Livrat-ok

Fiecare tranzitie este inregistrata cu data, ora si utilizatorul.`
      },
      {
        title: 'Filtrare si cautare',
        content: `Gasiti rapid comenzile dupa:
- Furnizor
- Status curent
- Perioada (data comanda, termen livrare)
- Numar comanda sau referinta`
      }
    ]
  },
  {
    id: 'montaj',
    title: 'Montaj',
    icon: Wrench,
    color: 'text-lime-600',
    bgColor: 'bg-lime-50',
    sections: [
      {
        title: 'Programare montaje',
        content: `Planificati si urmariti montajele:
- Calendar echipe de montaj
- Alocare resurse si echipamente
- Urmarire progres la fiecare santier
- Rapoarte finalizare`
      },
      {
        title: 'Gestionare echipe',
        content: `Pentru fiecare montaj:
- Atribuiti echipa responsabila
- Setati data si ora programata
- Adaugati observatii speciale
- Marcati finalizarea si adaugati poze`
      }
    ]
  },
  {
    id: 'depozit',
    title: 'Depozit',
    icon: Boxes,
    color: 'text-stone-600',
    bgColor: 'bg-stone-50',
    sections: [
      {
        title: 'Gestiune stocuri',
        content: `Modulul Depozit gestioneaza inventarul:
- Stocuri curente per produs/locatie
- Intrari si iesiri
- Transferuri intre locatii
- Inventarieri periodice`
      },
      {
        title: 'Operatiuni depozit',
        content: `Inregistrati:
- Receptii marfa de la furnizori
- Livrari catre clienti
- Transferuri interne
- Ajustari de inventar`
      }
    ]
  },
  {
    id: 'logistica',
    title: 'Logistica',
    icon: Truck,
    color: 'text-sky-600',
    bgColor: 'bg-sky-50',
    sections: [
      {
        title: 'Transport si livrari',
        content: `Gestionati logistica livrarilor:
- Planificare rute de transport
- Alocare vehicule si soferi
- Urmarire livrari in timp real
- Confirmari de livrare`
      },
      {
        title: 'Programare curse',
        content: `Pentru a programa o cursa:
1. Selectati comenzile de livrat
2. Grupati pe zone geografice
3. Alocati vehiculul si soferul
4. Generati foaia de parcurs
5. Urmariti confirmarile`
      }
    ]
  },
  {
    id: 'energie',
    title: 'Energie',
    icon: Zap,
    color: 'text-yellow-600',
    bgColor: 'bg-yellow-50',
    sections: [
      {
        title: 'Monitorizare consum',
        content: `Urmariti consumul de energie al firmei:
- Citiri contoare electrice, gaz, apa
- Inregistrare valori lunare per punct de consum
- Grafice evolutie consum pe perioade
- Alerte la depasirea pragurilor setate`
      },
      {
        title: 'Rapoarte consum',
        content: `Generati rapoarte detaliate:
- Comparatie consum luna curenta vs anterioara
- Comparatie an curent vs an precedent
- Cost mediu per unitate de masura
- Identificare varfuri de consum si anomalii`
      },
      {
        title: 'Puncte de consum',
        content: `Configurati punctele monitorizate:
- Sediu principal, hala productie, depozit
- Fiecare punct are propriul istoric
- Setati praguri de alerta per punct
- Export date pentru furnizorul de energie`
      }
    ]
  },
  {
    id: 'controlling',
    title: 'Controlling',
    icon: BarChart3,
    color: 'text-red-600',
    bgColor: 'bg-red-50',
    sections: [
      {
        title: 'Rapoarte si analize',
        content: `Controlling ofera date agregate pentru management:
- Sumar comenzi vanzare si achizitie
- Marje si profitabilitate
- Indicatori de performanta (KPI)
- Comparatii buget vs realizat`
      },
      {
        title: 'Vizualizare date',
        content: `Tabelul afiseaza date din multiple surse:
- Coloanele sunt colorate dupa status
- Sortare si filtrare avansata
- Export Excel (doar pentru admin)
- Coloane redimensionabile (preferintele se salveaza)`
      }
    ]
  },
  {
    id: 'efactura',
    title: 'e-Factura ANAF',
    icon: FileCheck,
    color: 'text-emerald-600',
    bgColor: 'bg-emerald-50',
    sections: [
      {
        title: 'Integrare e-Factura',
        content: `Modul pentru facturare electronica ANAF:
- Generare facturi in format XML
- Transmitere automata catre ANAF
- Verificare status facturi
- Descarcare raspunsuri si erori`
      },
      {
        title: 'Flux de lucru',
        content: `1. Creati factura in Comenzi Vanzare
2. Generati XML-ul e-Factura
3. Transmiteti catre ANAF
4. Verificati statusul (validat/respins)
5. Corectati erorile daca e cazul`
      }
    ]
  },
  {
    id: 'export_saga',
    title: 'Export SAGA',
    icon: FileSpreadsheet,
    color: 'text-blue-700',
    bgColor: 'bg-blue-50',
    sections: [
      {
        title: 'Export pentru contabilitate',
        content: `Generati fisiere pentru softul SAGA:
- Export facturi emise
- Export facturi primite
- Export incasari si plati
- Format compatibil cu SAGA C`
      },
      {
        title: 'Generare export',
        content: `1. Selectati perioada dorita
2. Alegeti tipul de documente
3. Verificati datele in preview
4. Descarcati fisierul pentru SAGA
5. Importati in softul de contabilitate`
      }
    ]
  },
  {
    id: 'configurator',
    title: 'Configurator',
    icon: Settings2,
    color: 'text-pink-600',
    bgColor: 'bg-pink-50',
    sections: [
      {
        title: 'Configurare produse',
        content: `Creati oferte personalizate pentru clienti:
- Selectati componentele produsului
- Calculul automat al pretului
- Vizualizare specificatii
- Generare oferta PDF`
      },
      {
        title: 'Utilizare',
        content: `1. Alegeti categoria de produs
2. Selectati optiunile dorite
3. Ajustati cantitatile
4. Verificati pretul calculat
5. Salvati configuratia sau generati oferta`
      }
    ]
  },
  {
    id: 'cereri_interne',
    title: 'Cereri Interne',
    icon: ClipboardList,
    color: 'text-slate-600',
    bgColor: 'bg-slate-50',
    sections: [
      {
        title: 'Solicitari interne',
        content: `Gestionati cererile interne ale angajatilor:
- Cereri de concediu
- Cereri de materiale/echipamente
- Solicitari diverse
- Workflow de aprobare`
      },
      {
        title: 'Creare cerere',
        content: `1. Selectati tipul de cerere
2. Completati detaliile
3. Atasati documente daca e necesar
4. Trimiteti pentru aprobare
5. Urmariti statusul cererii`
      }
    ]
  },
  {
    id: 'resurse_umane',
    title: 'Resurse Umane',
    icon: UsersRound,
    color: 'text-violet-600',
    bgColor: 'bg-violet-50',
    sections: [
      {
        title: 'Managementul personalului',
        content: `Modul HR complet:
- Dosare angajati
- Contracte si acte aditionale
- Istoric functii si salarii
- Evaluari periodice`
      },
      {
        title: 'Dosarul angajatului',
        content: `Fiecare dosar contine:
- Date personale si contact
- Documente (CI, contract, certificate)
- Istoric profesional in companie
- Note si observatii HR`
      }
    ]
  },
  {
    id: 'salarii',
    title: 'Salarii',
    icon: DollarSign,
    color: 'text-green-700',
    bgColor: 'bg-green-50',
    sections: [
      {
        title: 'Calcul salarii',
        content: `Modul pentru gestiunea salariilor angajatilor:
- Calcul automat pe baza pontajului lunar
- Salariu de baza + sporuri (noapte, weekend, sarbatori)
- Deduceri (avansuri, retineri, imprumuturi)
- Contributii angajat si angajator calculate automat`
      },
      {
        title: 'Fluturasi si rapoarte',
        content: `Generati documentele necesare:
- Fluturasi de salariu individuali (PDF)
- Centralizator salarii pe departament
- Declaratii lunare (D112)
- Export fisier pentru virament bancar (MultiCash)`
      },
      {
        title: 'Acces restricționat',
        content: `Modulul Salarii este accesibil doar pentru:
- Administrator (admin1@amel.ro)
- Financiar (financiar1@amel.ro)
- Grupuri autorizate: PontajF, PontajV, PontajA, PontajFa
Datele salariale sunt stocate criptat.`
      }
    ]
  },
  {
    id: 'financiar',
    title: 'Financiar',
    icon: FileUp,
    color: 'text-emerald-700',
    bgColor: 'bg-emerald-50',
    sections: [
      {
        title: 'Gestiune financiara',
        content: `Modulul Financiar centralizeaza datele financiare:
- Documente de livrare si receptie
- Validare financiara comenzi vanzare
- Solduri clienti si furnizori
- Situatii restante si scadente`
      },
      {
        title: 'Validare comenzi',
        content: `Procesul de validare financiara:
1. Comanda de vanzare ajunge la status "Livrat"
2. Departamentul financiar verifica documentele
3. Se seteaza data validarii financiare (data_val_fin)
4. Valoarea este inclusa in rapoartele de performanta
Toate valorile din sistem sunt CU TVA inclus.`
      },
      {
        title: 'Documente',
        content: `Gestionati documentele financiare:
- Upload documente livrare (CMR, aviz)
- Upload documente receptie (PV, NIR)
- Cautare dupa numar comanda sau furnizor
- Limita upload: 30 MB per fisier`
      }
    ]
  },
  {
    id: 'incasari',
    title: 'Incasari',
    icon: CreditCard,
    color: 'text-teal-700',
    bgColor: 'bg-teal-50',
    sections: [
      {
        title: 'Evidenta incasarilor',
        content: `Gestionati incasarile de la clienti:
- Inregistrare plati primite
- Alocare pe facturi
- Urmarire restante
- Notificari scadente`
      },
      {
        title: 'Inregistrare incasare',
        content: `1. Selectati clientul
2. Alegeti facturile de acoperit
3. Introduceti suma incasata
4. Selectati metoda de plata
5. Salvati incasarea`
      }
    ]
  },
  {
    id: 'recrutare',
    title: 'Recrutare',
    icon: UserPlus,
    color: 'text-rose-600',
    bgColor: 'bg-rose-50',
    sections: [
      {
        title: 'Proces de recrutare',
        content: `Gestionati candidaturile:
- Posturi deschise
- CV-uri primite
- Programare interviuri
- Evaluari candidati`
      },
      {
        title: 'Pipeline recrutare',
        content: `Urmariti candidatii prin etape:
CV Primit - Preselectat - Interviu HR - 
Interviu Tehnic - Oferta - Angajat/Respins`
      }
    ]
  },
  {
    id: 'scan_x',
    title: 'Scan-X',
    icon: ScanLine,
    color: 'text-gray-600',
    bgColor: 'bg-gray-50',
    sections: [
      {
        title: 'Scanare documente cu AI',
        content: `Scan-X foloseste inteligenta artificiala (Gemini Vision) pentru:
- Scanare facturi si extragere automata date
- Recunoastere OCR pe documente fizice
- Clasificare automata tip document
- Extragere campuri: furnizor, valoare, data, numar factura`
      },
      {
        title: 'Flux de lucru',
        content: `1. Fotografiati sau scanati documentul
2. Incarcati imaginea in Scan-X
3. AI-ul analizeaza si extrage datele automat
4. Verificati si corectati datele daca e necesar
5. Salvati sau exportati in modulul corespunzator`
      },
      {
        title: 'Tipuri documente suportate',
        content: `Scan-X poate procesa:
- Facturi (romanesti si internationale)
- Avize de insotire marfa
- CMR-uri (documente transport)
- Bonuri fiscale
Formate acceptate: JPG, PNG, PDF (max 30 MB)`
      }
    ]
  },
  // ===== SISTEM =====
  {
    id: 'utilizatori',
    title: 'Utilizatori',
    icon: UserPlus,
    color: 'text-blue-600',
    bgColor: 'bg-blue-50',
    sections: [
      {
        title: 'Gestionare conturi',
        content: `Administrati conturile de utilizator:
- Adaugare utilizatori noi
- Setare/resetare parola
- Atribuire la grupuri
- Activare/dezactivare conturi`
      },
      {
        title: 'Permisiuni',
        content: `Fiecare utilizator primeste drepturi prin:
- Grupul din care face parte
- Permisiuni individuale (exceptii)
- Rol (Admin, Agent, Operator, etc.)`
      }
    ]
  },
  {
    id: 'grupuri',
    title: 'Grupuri',
    icon: UsersRound,
    color: 'text-purple-600',
    bgColor: 'bg-purple-50',
    sections: [
      {
        title: 'Organizare pe grupuri',
        content: `Grupurile simplifica managementul drepturilor:
- Creati grupuri per departament sau rol
- Atribuiti permisiuni la nivel de grup
- Utilizatorii mostenesc drepturile grupului`
      },
      {
        title: 'Grupuri existente',
        content: `Exemple de grupuri configurate:
- PontajF, PontajV, PontajA, PontajFa (acces pontaj + salarii)
- Agent Vanzari (acces CRM, Clienti, Comenzi Vanzare)
- Financiar (acces Financiar, Incasari, Facturi)
- Productie (acces Comenzi Achizitie, Depozit)
Fiecare utilizator apartine unui singur grup.`
      },
      {
        title: 'Creare grup nou',
        content: `1. Accesati pagina Grupuri
2. Click pe "Adauga grup"
3. Introduceti numele grupului
4. Salvati, apoi mergeti la Drepturi pentru a seta permisiunile
Disponibil doar pentru administratori.`
      }
    ]
  },
  {
    id: 'drepturi',
    title: 'Drepturi',
    icon: Key,
    color: 'text-amber-600',
    bgColor: 'bg-amber-50',
    sections: [
      {
        title: 'Matrice de permisiuni',
        content: `Configurati accesul granular per grup:
- Per modul (Clienti, Comenzi, CRM, Financiar, etc.)
- Per actiune (vizualizare, adaugare, editare, stergere)
- Export date (Excel, PDF)
- Functii speciale (aprobare, finalizare, validare)`
      },
      {
        title: 'Cum functioneaza',
        content: `Sistemul de drepturi are 3 niveluri:
1. Admin: acces total la toate modulele si functiile
2. Grup: permisiunile setate in pagina Drepturi per grup
3. Restrictii suplimentare: unele module au restrictii pe email
   (ex: Salarii doar financiar1@amel.ro si admin1@amel.ro)
Stergerea este permisa doar admin-ului si financiarului.`
      },
      {
        title: 'Modificare drepturi',
        content: `1. Selectati grupul din lista
2. Bifati/debifati permisiunile pe fiecare modul
3. Salvati modificarile
Modificarile se aplica imediat la urmatoarea incarcare de pagina.
Disponibil doar pentru administratori.`
      }
    ]
  },
  {
    id: 'nomenclatoare',
    title: 'Nomenclatoare',
    icon: Globe,
    color: 'text-green-600',
    bgColor: 'bg-green-50',
    sections: [
      {
        title: 'Liste predefinite',
        content: `Gestionati valorile din dropdown-uri:
- Coduri postale si localitati
- Tipuri de activitati
- Statusuri personalizate
- Categorii produse`
      },
      {
        title: 'Coduri postale',
        content: `Baza de date contine ~38.000 coduri pentru Romania, 
plus alte tari europene (FR, DE, IT, ES, etc.)
Folosit pentru auto-completare adrese.`
      }
    ]
  },
  {
    id: 'configurari_firma',
    title: 'Configurari Firma',
    icon: Building2,
    color: 'text-emerald-600',
    bgColor: 'bg-emerald-50',
    sections: [
      {
        title: 'Datele firmei',
        content: `Setati informatiile care apar pe documente:
- Nume firma, CUI, Reg.Com
- Adresa sediului social
- Capital social
- Conturi bancare (IBAN RON/EUR)
- Date de contact`
      },
      {
        title: 'Utilizare',
        content: `Aceste date sunt preluate automat in:
- Proforme si facturi
- Oferte si contracte
- Documente de transport
- Email-uri trimise clientilor`
      }
    ]
  },
  {
    id: 'integrari_api',
    title: 'Integrari API',
    icon: Key,
    color: 'text-indigo-600',
    bgColor: 'bg-indigo-50',
    sections: [
      {
        title: 'Conexiuni externe',
        content: `Configurati integrarile cu servicii externe:
- OpenAPI.ro pentru date firme (CAEN, bilanturi)
- WhatsApp Business API
- Email (SMTP/IMAP)
- Alte servicii terte`
      },
      {
        title: 'Configurare',
        content: `Pentru fiecare integrare:
1. Obtineti cheia API de la furnizor
2. Introduceti credentialele in sistem
3. Testati conexiunea
4. Activati integrarea`
      }
    ]
  },
  // ===== MODULE LIPSA ADAUGATE =====
  {
    id: 'documentatii',
    title: 'Documentatii',
    icon: FileText,
    color: 'text-slate-600',
    bgColor: 'bg-slate-50',
    sections: [
      {
        title: 'Documentatie sistem',
        content: `Acces la documentatia tehnica si operationala:
- Versiuni si changelog aplicatie
- Documentatie module (CRM, Notificari, Email, Depozit)
- Ghiduri de deploy si backup
- Documentatie activitati sistem`
      },
      {
        title: 'Descarcare',
        content: `Documentele sunt disponibile in format PDF.
Selectati documentul dorit si apasati butonul de descarcare.
Disponibil doar pentru administratori.`
      }
    ]
  },
  {
    id: 'business_intelligence',
    title: 'Business Intelligence',
    icon: Brain,
    color: 'text-purple-600',
    bgColor: 'bg-purple-50',
    sections: [
      {
        title: 'Rapoarte BI',
        content: `Analiza avansata a datelor din CRM:
- Leads: surse, conversii, evolutie lunara
- Oferte: valori, rate de succes, comparatie agenti
- Clienti: distributie geografica, segmentare
- Comenzi vanzare si achizitie: tendinte, valori`
      },
      {
        title: 'Comparatie ani',
        content: `Comparati performanta pe perioade:
- Selectati metrica (leads, oferte, comenzi)
- Alegeti agentul sau toti agentii
- Vizualizati grafice comparative an peste an
Disponibil doar pentru administratori.`
      }
    ]
  },
  {
    id: 'notificari_comenzi',
    title: 'Notificari Comenzi',
    icon: Bell,
    color: 'text-amber-600',
    bgColor: 'bg-amber-50',
    sections: [
      {
        title: 'Setari notificari comenzi',
        content: `Configurati cine primeste notificari la schimbarea statusului comenzilor:
- Notificari la crearea comenzii
- Notificari la schimbarea statusului
- Notificari la validare financiara
- Selectare destinatari per tip eveniment`
      },
      {
        title: 'Canale notificare',
        content: `Notificarile se trimit pe:
- Email (via Resend)
- Notificari in aplicatie (clopotel)
Disponibil doar pentru administratori.`
      }
    ]
  },
  {
    id: 'notificari',
    title: 'Notificari',
    icon: Bell,
    color: 'text-red-600',
    bgColor: 'bg-red-50',
    sections: [
      {
        title: 'Centru notificari',
        content: `Vizualizati toate notificarile primite:
- Notificari noi (necitite) marcate cu culoare distincta
- Filtrare dupa tip (comenzi, depozit, sistem, email)
- Marcare ca citite individual sau toate deodata
- Istoric complet al notificarilor primite`
      },
      {
        title: 'Tipuri de notificari',
        content: `Sistemul trimite notificari automate pentru:
- Schimbari status comenzi vanzare si achizitie
- Livrari noi in depozit (documente lipsa, validare)
- Email-uri primite (bounce, raspunsuri)
- Activitati CRM programate
Notificarile se trimit atat in aplicatie (clopotel) cat si pe email.`
      },
      {
        title: 'Clopotelul de notificari',
        content: `In bara de sus apare numarul de notificari necitite.
Click pe clopotel deschide lista rapida.
Notificarile se trimit doar utilizatorilor ACTIVI (is_active=true).
Disponibil doar pentru administratori.`
      }
    ]
  },
  {
    id: 'sesiuni',
    title: 'Sesiuni',
    icon: Clock,
    color: 'text-cyan-600',
    bgColor: 'bg-cyan-50',
    sections: [
      {
        title: 'Monitorizare sesiuni',
        content: `Vizualizati sesiunile active si istoricul conectarilor:
- Utilizatori conectati in timp real
- Ora ultimei activitati
- Durata sesiunii
- Istoric login/logout per utilizator`
      },
      {
        title: 'Securitate',
        content: `Sesiunile expira automat dupa 1 ora de inactivitate.
Token-ul JWT expira dupa 1 ora.
Disponibil doar pentru administratori.`
      }
    ]
  },
  {
    id: 'ajutor',
    title: 'Ajutor',
    icon: HelpCircle,
    color: 'text-blue-600',
    bgColor: 'bg-blue-50',
    sections: [
      {
        title: 'Centrul de Ajutor',
        content: `Aceasta pagina contine documentatia completa a aplicatiei ERP:
- Ghid Module: instructiuni detaliate pentru fiecare ecran
- FAQ: raspunsuri la intrebarile frecvente
- Scurtaturi: combinatii de taste pentru navigare rapida`
      },
      {
        title: 'Cautare informatii',
        content: `Pentru a gasi rapid informatii:
1. Selectati tab-ul dorit (Ghid Module, FAQ, Scurtaturi)
2. In Ghid Module, click pe modulul de interes
3. Cititi sectiunile expandate cu instructiuni pas cu pas
Documentatia se actualizeaza la fiecare versiune a aplicatiei.`
      }
    ]
  }
];

// FAQ
const FAQ_ITEMS = [
  {
    q: 'Cum pot reseta parola?',
    a: 'Contactati administratorul sistemului pentru resetarea parolei. Din motive de securitate, nu exista optiune de auto-resetare.'
  },
  {
    q: 'De ce nu vad toate meniurile?',
    a: 'Accesul la module este controlat prin sistemul de permisiuni. Daca nu vedeti un modul, contactati administratorul pentru a verifica drepturile grupului dvs.'
  },
  {
    q: 'Cum functioneaza "Agent Partajat"?',
    a: 'Campul "Agent Partajat" permite vizibilitatea inregistrarilor pentru mai multi agenti. Daca numele dvs. apare in campul Agent sau Agent Partajat, veti vedea acea inregistrare.'
  },
  {
    q: 'Ce inseamna erorile la import Excel?',
    a: 'Verificati ca: 1) Fisierul este in format .xlsx, .xls sau .csv, 2) Coloanele au numele corecte (descarcati sablonul), 3) Nu exista caractere speciale in date.'
  },
  {
    q: 'Cum pot exporta date in Excel?',
    a: 'Butonul "Export Excel" este disponibil in paginile care suporta export. In Controlling, exportul este disponibil doar pentru administratori.'
  },
  {
    q: 'Ce este VIES si ANAF?',
    a: 'VIES = sistem european de validare TVA (pentru firme din UE). ANAF = date despre firme romanesti. Ambele permit auto-completarea datelor la adaugarea clientilor.'
  },
  {
    q: 'Cum pot vedea istoricul modificarilor?',
    a: 'Click dreapta pe o inregistrare sau folositi meniul "Actiuni" - "Log actiuni" pentru a vedea toate modificarile, cine le-a facut si cand.'
  },
  {
    q: 'De ce nu pot sterge o inregistrare?',
    a: 'Stergerea este permisa doar administratorilor. Contactati un admin daca aveti nevoie sa stergeti date.'
  }
];

// Scurtaturi tastatura
const SHORTCUTS = [
  { keys: ['Ctrl', 'F'], description: 'Focus pe campul de cautare' },
  { keys: ['Enter'], description: 'Confirma actiunea / Salveaza' },
  { keys: ['Esc'], description: 'Inchide dialogul / Anuleaza' },
  { keys: ['Tab'], description: 'Navigheaza intre campuri' },
  { keys: ['Up', 'Down'], description: 'Navigheaza in liste/tabele' }
];

export const Ajutor = () => {
  const [activeModule, setActiveModule] = useState(null);
  const [expandedFaq, setExpandedFaq] = useState(null);
  const [activeTab, setActiveTab] = useState('ghid');

  const tabs = [
    { id: 'ghid', label: 'Ghid Module', icon: Book },
    { id: 'faq', label: 'FAQ', icon: HelpCircle },
    { id: 'shortcuts', label: 'Scurtaturi', icon: Keyboard }
  ];

  return (
    <div className="p-6 max-w-6xl mx-auto" data-testid="ajutor-page">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <HelpCircle className="w-7 h-7 text-blue-600" />
          Centru de Ajutor
        </h1>
        <p className="text-gray-500 mt-1">Documentatie si ghiduri pentru utilizarea aplicatiei ERP</p>
      </div>

      {/* Tabs */}
      <div className="flex gap-2 mb-6 flex-wrap">
        {tabs.map(tab => {
          const Icon = tab.icon;
          return (
            <Button
              key={tab.id}
              variant={activeTab === tab.id ? 'default' : 'outline'}
              onClick={() => setActiveTab(tab.id)}
              className={activeTab === tab.id ? 'bg-blue-600' : ''}
            >
              <Icon className="w-4 h-4 mr-2" />
              {tab.label}
            </Button>
          );
        })}
      </div>

      {/* Ghid Module */}
      {activeTab === 'ghid' && (
        <div className="space-y-4">
          <p className="text-gray-600 mb-4">
            Selectati un modul pentru a vedea instructiunile de utilizare ({MODULE_GUIDES.length} module disponibile):
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {MODULE_GUIDES.map(module => {
              const Icon = module.icon;
              const isActive = activeModule === module.id;
              
              return (
                <Card 
                  key={module.id}
                  className={`cursor-pointer transition-all hover:shadow-md ${
                    isActive ? 'ring-2 ring-blue-500' : ''
                  }`}
                  onClick={() => setActiveModule(isActive ? null : module.id)}
                >
                  <CardHeader className="pb-2">
                    <CardTitle className="flex items-center gap-3 text-lg">
                      <div className={`p-2 rounded-lg ${module.bgColor}`}>
                        <Icon className={`w-5 h-5 ${module.color}`} />
                      </div>
                      {module.title}
                      {isActive ? (
                        <ChevronDown className="w-4 h-4 ml-auto text-gray-400" />
                      ) : (
                        <ChevronRight className="w-4 h-4 ml-auto text-gray-400" />
                      )}
                    </CardTitle>
                  </CardHeader>
                  {isActive && (
                    <CardContent className="pt-0">
                      <div className="space-y-4 mt-2">
                        {module.sections.map((section, idx) => (
                          <div key={idx} className="border-l-2 border-blue-200 pl-3">
                            <h4 className="font-medium text-gray-900 mb-1">{section.title}</h4>
                            <p className="text-sm text-gray-600 whitespace-pre-line">{section.content}</p>
                          </div>
                        ))}
                      </div>
                    </CardContent>
                  )}
                </Card>
              );
            })}
          </div>
        </div>
      )}

      {/* FAQ */}
      {activeTab === 'faq' && (
        <div className="space-y-3">
          {FAQ_ITEMS.map((item, idx) => (
            <Card 
              key={idx}
              className="cursor-pointer"
              onClick={() => setExpandedFaq(expandedFaq === idx ? null : idx)}
            >
              <CardHeader className="py-3">
                <CardTitle className="flex items-center justify-between text-base font-medium">
                  <span className="flex items-center gap-2">
                    <HelpCircle className="w-4 h-4 text-blue-500" />
                    {item.q}
                  </span>
                  {expandedFaq === idx ? (
                    <ChevronDown className="w-4 h-4 text-gray-400" />
                  ) : (
                    <ChevronRight className="w-4 h-4 text-gray-400" />
                  )}
                </CardTitle>
              </CardHeader>
              {expandedFaq === idx && (
                <CardContent className="pt-0 pb-4">
                  <p className="text-gray-600 text-sm">{item.a}</p>
                </CardContent>
              )}
            </Card>
          ))}
        </div>
      )}

      {/* Shortcuts */}
      {activeTab === 'shortcuts' && (
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Keyboard className="w-5 h-5" />
              Scurtaturi Tastatura
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              {SHORTCUTS.map((shortcut, idx) => (
                <div key={idx} className="flex items-center justify-between py-2 border-b last:border-0">
                  <div className="flex gap-1">
                    {shortcut.keys.map((key, kidx) => (
                      <React.Fragment key={kidx}>
                        <kbd className="px-2 py-1 bg-gray-100 border border-gray-300 rounded text-sm font-mono">
                          {key}
                        </kbd>
                        {kidx < shortcut.keys.length - 1 && (
                          <span className="text-gray-400 mx-1">+</span>
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                  <span className="text-gray-600 text-sm">{shortcut.description}</span>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Contact */}
      {activeTab === 'contact' && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Mail className="w-5 h-5 text-blue-600" />
                Email Suport
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600 mb-3">
                Pentru intrebari sau probleme tehnice, ne puteti contacta la:
              </p>
              <a 
                href="mailto:support@amel.ro" 
                className="text-blue-600 hover:underline font-medium"
              >
                support@amel.ro
              </a>
              <p className="text-sm text-gray-500 mt-3">
                Timp mediu de raspuns: 24 ore lucratoare
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Phone className="w-5 h-5 text-green-600" />
                Telefon
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600 mb-3">
                Pentru urgente sau asistenta telefonica:
              </p>
              <a 
                href="tel:+40212038100" 
                className="text-green-600 hover:underline font-medium"
              >
                +40 21 203 8100
              </a>
              <p className="text-sm text-gray-500 mt-3">
                Program: Luni - Vineri, 09:00 - 18:00
              </p>
            </CardContent>
          </Card>

          <Card className="md:col-span-2">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <ExternalLink className="w-5 h-5 text-purple-600" />
                Resurse Externe
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <a 
                  href="https://mfinante.gov.ro" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 p-3 border rounded-lg hover:bg-gray-50 transition-colors"
                >
                  <Globe className="w-5 h-5 text-blue-600" />
                  <div>
                    <div className="font-medium">ANAF</div>
                    <div className="text-xs text-gray-500">Verificare firme RO</div>
                  </div>
                </a>
                <a 
                  href="https://portal.onrc.ro" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 p-3 border rounded-lg hover:bg-gray-50 transition-colors"
                >
                  <Globe className="w-5 h-5 text-green-600" />
                  <div>
                    <div className="font-medium">ONRC</div>
                    <div className="text-xs text-gray-500">Registrul Comertului</div>
                  </div>
                </a>
                <a 
                  href="https://ec.europa.eu/taxation_customs/vies/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 p-3 border rounded-lg hover:bg-gray-50 transition-colors"
                >
                  <Globe className="w-5 h-5 text-purple-600" />
                  <div>
                    <div className="font-medium">VIES</div>
                    <div className="text-xs text-gray-500">Validare TVA UE</div>
                  </div>
                </a>
              </div>
            </CardContent>
          </Card>
        </div>
      )}
    </div>
  );
};
